import {
  Get_CondfigPromocodeCampaginsQuery,
  Get_CondfigPromocodeCampaginsQueryVariables,
} from "@/types/gql/generated/graphql";
import { apolloClient } from "@/utils/graphql-client";
import { GET_CondfigPromocodeCampagins } from "./queries/promocode-campaign.graphql";
import { IPaginate } from "@/types/app";

/**
 * Get PromocodeCampaigns linked to a posConfig
 *
 * @param posConfigId: number
 */
export async function getPromocodeCampaginsByConfigId(
  configId: number,
  pagination?: IPaginate
) {
  const variables: Get_CondfigPromocodeCampaginsQueryVariables = {
    condition: `(pos_config_id,eq,${configId})`,
  };

  if (pagination) {
    variables.skip = pagination.skip;
    variables.limit = pagination.limit;
  }
  const res = await apolloClient.query<
    Get_CondfigPromocodeCampaginsQuery,
    Get_CondfigPromocodeCampaginsQueryVariables
  >({
    query: GET_CondfigPromocodeCampagins,
    variables,
  });

  const promocodeCampaings = res.data.promocodeCampaignList || [];
  return promocodeCampaings;
}
